import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[mcHighLowValue]'
})
export class HighLowValueDirective implements OnChanges {
  @Input() value: number;
  @Input() baseValue: number;

  highColor = '#ff0000';    // Red
  lowColor = '#22b14c';     // Green

  constructor(private el: ElementRef) { }

  ngOnChanges() {
    let selectedColor = this.lowColor;

    if (this.value > this.baseValue) {
      selectedColor = this.highColor;
    }

    this.el.nativeElement.style.color = selectedColor;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/high-low-value/high-low-value.directive.ts